<template>
    <v-container fluid class="signin-container">
        <v-row no-gutters justify="center">
            <v-col cols="5" class="signin-container__content">
                <v-row no-gutters justify="center">
                    <v-col cols="4" class="mb-10 ml-5 rounded-lg ">
                       <v-list-item href="https://roadcube.com" class="d-flex justify-center align-center rounded-lg " style="max-width: 200px;"> <img
                                src="@/assets/home/logo-sticky.png"
                                width="160"
                                style="vertical-align: middle"
                            /></v-list-item>
                    </v-col>
                    <v-col cols="12">
                        <v-card
                            outlined
                            class="signin-container__card"
                            v-if="!accessToken"
                        >
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-card-title
                                        class="text-h6 font-weight-black pl-0"
                                    >
                                    {{ translations.welcome[lang] }}
                                    </v-card-title>
                                </v-col>

                                <v-card-subtitle
                                    class="
                                        font-weight-bold
                                        black--text
                                        pl-0
                                        pt-0
                                    "
                                >
                                {{ translations.enter[lang] }}
                                </v-card-subtitle>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="mobile"
                                        v-mask="'##########'"
                                        type="number"
                                        :label="translations.mobile[lang]"
                                        color="primary"
                                        class="mt-5"
                                        outlined
                                        solo
                                        flat
                                        dense
                                        clearable
                                        :success="success.mobile"
                                        :error-messages="error.mobile"
                                        @keyup.enter="signIn()"
                                        @blur="validateMobile"
                                    >
                                        <template v-slot:prepend-inner>
                                            <v-select
                                                style="max-width: 120px;max-height: 38px;"
                                                class="pt-0 ml-0 pl-0 countrySelect"
                                                v-model="storeDetails.country_id"
                                                item-value="country_id"
                                                :items="activeCountries"
                                                menu-props="offsetY"
                                                :label="translations.country[lang]"
                                                solo
                                                flat
                                                dense
                                                color="secondary"
                                                item-color="secondary"
                                                :success="success.country"
                                                :error-messages="error.country"
                                                @focus="error.country = ''"
                                                @blur="validateCountry"
                                            >
                                            <template v-slot:label style="min-width:80px">
                                                  <span>{{ translations.country[lang] }}</span>
                                                </template>
                                                <template v-slot:selection="{ item }">
                                                            <v-row no-gutters class="d-flex align-center">
                                                <v-col class="mr-0">
                                                    <img
                                                        :src="item.flag"
                                                        width="25"
                                                        style="vertical-align: middle"
                                                        class="mr-0"
                                                    />
                                                </v-col>

                                                <v-col cols="auto">{{ item.phone_code }}</v-col>
                                            </v-row>
                                                </template>
                                                <template v-slot:item="{ item }">
                                                    <v-row no-gutters>
                                                        <v-col class="mr-3">
                                                            <img
                                                                :src="item.flag"
                                                                width="25"
                                                                style="vertical-align: middle"
                                                                class="mr-3"
                                                            />
                                                            {{ item.name }} ({{ item.code }})
                                                        </v-col>

                                                        <v-col cols="auto"
                                                            >{{ item.phone_code }}</v-col
                                                        >
                                                    </v-row>
                                                </template>
                                            </v-select>
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        v-model="password"
                                        ref="password"
                                        :type="
                                            showPassword ? 'text' : 'password'
                                        "
                                        :label="translations.password[lang]"
                                        color="secondary"
                                        outlined
                                        solo
                                        flat
                                        dense
                                        clearable
                                        hide-details="auto"
                                        :append-icon="icons.mdiEye"
                                        :success="success.password"
                                        :error-messages="error.password"
                                        @blur="validatePassword"
                                        @click:append="
                                            showPassword = !showPassword
                                        "
                                        @keyup.enter="signIn()"
                                    ></v-text-field>
                                </v-col>

                                <v-alert
                                    v-if="errorMessage"
                                    type="error"
                                    class="mt-5"
                                    >{{ errorMessage }}</v-alert
                                >

                                <v-col cols="12">
                                    <v-btn
                                        :loading="loading"
                                        :disabled="disabled"
                                        @click="signIn"
                                        class="card__btn mt-5"
                                    >
                                    {{ translations.logIn[lang] }}
                                    </v-btn>
                                </v-col>

                                <v-col cols="12" class="card__add-text">
                                    {{ translations.notRegistered[lang] }}  {{ translations.createA[lang] }}
                                    <span
                                        class="card__links"
                                        @click="goToUserRegistration"
                                        >{{ translations.newAccount[lang] }}</span
                                    >
                                    |
                                    <span
                                        class="card__links"
                                        @click="forgotPassword()"
                                        >{{ translations.forgotPassword[lang] }}</span
                                    >
                                </v-col>
                            </v-row>
                        </v-card>

                        <v-card outlined class="signin-container__card" v-else>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-card-title
                                        class="text-h6 font-weight-black pl-0"
                                    >
                                    {{ translations.welcomeBack[lang] }}
                                    </v-card-title>
                                </v-col>

                                <v-col cols="12">
                                    <v-card-title
                                        class="text-h6 font-weight-bold pl-0"
                                    >
                                        {{ $store.state.user.full_name || '' }}
                                    </v-card-title>
                                </v-col>

                                <v-col cols="6">
                                    <v-btn
                                        :loading="loading"
                                        @click="logout"
                                        class="card__btn mt-5"
                                    >
                                    {{ translations.logout[lang] }}
                                    </v-btn>
                                </v-col>

                                <v-col cols="6">
                                    <v-btn
                                        :loading="loading"
                                        @click="goToUserStores"
                                        class="card__btn mt-5"
                                    >
                                    {{ translations.myStores[lang] }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mdiEye, mdiArrowRight } from "@mdi/js";
import axios from "axios";
import { mapMutations, mapState, mapActions } from "vuex";
import API from "@/models/API";
import validators from "@/utils/validators/general/createAccount";
import translations from "@/utils/translations/signIn";

export default {
    name: "SignIn",
    mixins: [validators, translations],

    data() {
        return {
            icons: { mdiEye, mdiArrowRight },
            // valid: false,
            disabled: true,
            loading: false,
            errorMessage: "",
            mobile: "",
            password: "",
            storeDetails: {
                country_id: null,
            },
            showPassword: false,
            app_provider_id: null,
            dialog: false,
            tos: false,
        };
    },

    computed: {
        ...mapState(["accessToken", "activeCountries"]),
        lang() {
            return this.$route.params.lang;
        },
        countryId() {
            return this.storeDetails?.country_id;
        }
    },

    created() {
        this.createAppProvider();
    },

    methods: {
        ...mapMutations(["setAccessToken", "setUser", "setPermissions"]),
        ...mapActions(["loadActiveCountries"]),
        ...mapMutations("register", [
            "setFullname",
            "setPassword",
            "setConfirmPassword",
        ]),

        goToUserRegistration() {
            localStorage.removeItem("registrationStep");
            localStorage.removeItem("country");
            localStorage.removeItem("mobile");
            localStorage.removeItem("userRegistrationIdentifier");
            localStorage.removeItem("subscriptionPlan");
            localStorage.removeItem("providerStoreId");
            localStorage.removeItem("appProvider");
            this.$router.push(`/${this.lang}/create-account`);
        },

        async logout() {
            try {
                const { data } = await API.post(`/users/logout`);

                localStorage.removeItem("storeId");
                localStorage.removeItem("companyId");
                localStorage.removeItem("accessToken");
                this.setAccessToken("");
            } catch (ex) {
                console.error(ex.response?.data || ex);
            }
        },

        async createAppProvider() {
            try {
                const { data } = await API.post(`/common/info/app-provider`, {
                    web_app_token: "rce37224-98a8-2178-adb4-602ds577b9b1",
                });
                this.app_provider_id = data.data.app_provider_id;
            } catch (ex) {
                console.error(ex.response?.data || ex);
            }
        },

        goToUserStores() {
            this.$router.push(`/${this.lang}/user-stores`);
        },

        async signIn() {
            try {
                this.loading = true;
                const { data } = await API.post(`/users/login`, {
                    app_provider_id: this.app_provider_id,
                    mobile: this.mobile,
                    password: this.password,
                    country_id: this.countryId
                });
                this.setAccessToken(data.access_token);
                localStorage.setItem("accessToken", data.access_token);

                // if(data.extra_data.user_stores.length > 0){
                //     data.extra_data.user.role =
                //     data.extra_data.user_stores[0].role.name;
                //     this.setPermissions(data.extra_data.user_stores[0].permissions);
                // }else{
                //     this.setFullname(data.extra_data.user.full_name);
                //     this.setPassword(this.password);
                //     this.setConfirmPassword(this.password);
                // }

                this.setFullname(data.extra_data.user.full_name);
                this.setPassword(this.password);
                this.setConfirmPassword(this.password);

                this.setUser(data.extra_data.user);
                this.$router.push(`/${this.lang}/user-stores`);
            } catch (ex) {
                this.loading = false;
                this.errorMessage = ex.response.data.message;
                setTimeout(() => (this.errorMessage = ""), 5000);
            }
        },

        forgotPassword() {
            this.$router.push(`/${this.lang}/password-recovery`);
        },
    },
    mounted() {
        this.loadActiveCountries()
    },

    watch: {
        valid(val) {
            if (val) {
                this.disabled = false;
            } else {
                this.disabled = true;
            }
        },
        activeCountries: { 
            immediate: true,
            handler(val) {
                this.storeDetails.country_id = this.storeDetails.country_id||val[0]?.country_id
        },
        deep: true
    }
    },
};
</script>

<style>
.v-select.countrySelect > .v-input__control > .v-input__slot {
  cursor: pointer;
  padding-left: 0 !important;
}

.countrySelect {
    min-width: 120px;
    background: white;
    border-right: 1px dotted grey;
    margin-right: 12px;
}
.v-label {
    font-size: 0.885rem;
    font-weight: 500;
}

.v-application .success--text {
    color: rgb(158 158 158);
}
</style>

<style scoped lang="scss">
.b-signin-container {
    height: 100%;
    padding: 0;
    background-color: #0089f3;
    background-image: url("../assets/home/hero-trans.png"),
        url("../assets/home/hero-bottom.png");
    background-repeat: no-repeat no-repeat;
    background-position: center top, center bottom;
}

.signin-container {
    height: 100%;
    padding: 0;
    background-color: #f5f5fd;
    font-family: "Roboto", sans-serif;

    .signin-container__content {
        margin-top: 6%;

        .signin-container__card {
            padding: 20px 100px;
        }
    }

    .card__btn {
        background-color: #2255fe !important;
        color: #f5f5fd;
        letter-spacing: 1px;
    }

    .card__add-text {
        font-size: 12px;
        margin-top: 50px;
        font-weight: bold;

        .card__links {
            text-decoration: underline;
            cursor: pointer;
        }
    }
}

.centered-input >>> input {
    text-align: center;
}

.b-nav-link {
    padding: 0 16px;
    color: white;
    text-decoration: none;
    opacity: 0.5;
    font-size: 14px;
    font-weight: 600;
}

.b-nav-link:hover {
    opacity: 1;
}

.b-wrapper {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.b-video-main {
    position: relative;
    display: inline-block;
}

.b-video {
    height: 100px;
    width: 100px;
    line-height: 95px;
    text-align: center;
    border-radius: 100%;
    color: #fff;
    display: inline-block;
    background: #001266;
    z-index: 999;
}

.play-btn {
    width: 32px;
}

@keyframes waves {
    0% {
        -webkit-transform: scale(0.2, 0.2);
        transform: scale(0.2, 0.2);
        opacity: 0;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    }
    50% {
        opacity: 0.9;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";
    }
    100% {
        -webkit-transform: scale(0.9, 0.9);
        transform: scale(0.9, 0.9);
        opacity: 0;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    }
}

.fa-play:before {
    content: "\f04b";
}

.b-waves {
    position: absolute;
    width: 200px;
    height: 200px;
    background: rgba(71, 61, 95, 0.7);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    border-radius: 100%;
    top: -50px;
    left: -50px;
    z-index: -1;
    -webkit-animation: waves-data-v-5de664c6 3s ease-in-out infinite;
    animation: waves-data-v-5de664c6 3s ease-in-out infinite;
}

.b-wave-1 {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
}

.b-wave-2 {
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
}

.b-wave-3 {
    -webkit-animation-delay: 2s;
    animation-delay: 2s;
}

.b-video-dialog {
    max-width: 960px;
    margin: 0 auto;
    height: calc(100vw / 2.96);
}

.b-video-close-btn {
    width: auto;
    background-color: transparent;
    position: absolute;
    top: 20px;
    right: 20px;
}

.b-video-close-btn::before {
    background-color: transparent !important;
}
</style>
